import { createTheme } from '@mui/material';
import { blue, teal } from '@mui/material/colors';

export const appTheme = createTheme({
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 900,
			lg: 1280,
			xl: 1920,
		},
	},
	palette: {
		primary: process.env.APP_ENV === 'production' ? teal : blue,
	},
	components: {
		MuiTypography: {
			styleOverrides: {
				subtitle1: {
					fontSize: '1.125rem',
				},
			},
		},
		MuiTextField: {
			defaultProps: {
				variant: 'standard',
			},
		},
		MuiFormControl: {
			defaultProps: {
				variant: 'standard',
			},
		},
		MuiButtonGroup: {
			styleOverrides: {
				grouped: {
					minWidth: 96,
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				labelIcon: {
					minHeight: 48,
				},
			},
		},
	},
	zIndex: {
		appBar: 1350,
	},
});
